import React from 'react';

/**
 * AuthPageLayout provides a consistent, full-height, centered layout
 * for authentication-related screens.
 *
 * Screen components rendered within this layout should define their own
 * column width (e.g., <div className="col-md-6 mx-auto">...</div>).
 */
function AuthPageLayout({ children }) {
  return (
    <div className="container-fluid h-100">
      <div className="row h-100 align-items-center justify-content-center">
        {children}
      </div>
    </div>
  );
}

export default AuthPageLayout;